import { useGLTF } from "@react-three/drei";
import LoadingLayout from "features/shared/loading-layout";
import { useEffect } from "react";
import Container from "shared/ui/container";
import { getFullAssetPath } from "shared/utils/assets";
import { isDevelopmentEnvironment } from "shared/utils/checkEnvironment";
import { twMerge } from "tailwind-merge";
import BusinessConfiguratorOptions from "widgets/business-configurator/options";
import BusinessConfiguratorProduct from "widgets/business-configurator/product";

const BusinessConfigurator = () => {
  useEffect(() => {
    useGLTF.preload(
      getFullAssetPath("/objects-v3/kaderdeurEnkelGoodMirrored.glb"),
    );
    useGLTF.preload(
      getFullAssetPath("/objects-v3/kaderdeurSilverHandles-v1.glb"),
    );
    useGLTF.preload(getFullAssetPath("/objects-v3/materialsCompressedv4.glb"));
    useGLTF.preload(getFullAssetPath("/objects-v3/kaderdeur-dubbel.glb"));
    useGLTF.preload(getFullAssetPath("/objects-v3/kaderdeurKozijn.glb"));
    useGLTF.preload(getFullAssetPath("/objects-v3/chairbaked2-v1.glb"));
  }, []);

  return (
    <>
      <main
        className={twMerge(
          isDevelopmentEnvironment() ? "gg-pt-7 md:gg-pt-8" : "",
          "gg-pb-24",
        )}
      >
        <Container
          className={twMerge(
            isDevelopmentEnvironment() ? "gg-gap-4 gg-p-6" : "",
            "gg-relative gg-grid gg-grid-cols-12 gg-items-start 2xl:!gg-max-w-screen-xl",
          )}
        >
          <LoadingLayout isStandardProduct={false} />
          <div className="gg-relative gg-col-span-12 gg-grid gg-h-max gg-grid-cols-12 gg-items-start">
            <BusinessConfiguratorOptions className="gg-order-2 gg-col-span-12 lg:gg-order-1 lg:gg-col-span-5" />
            <BusinessConfiguratorProduct className="gg-order-1 gg-col-span-12 gg-mb-4 lg:gg-order-2 lg:gg-col-span-7 lg:gg-mb-0 lg:gg-ml-12" />
          </div>
        </Container>
        <div
          id="footersGridElements"
          className="gg-container gg-fixed gg-bottom-0 gg-left-0 gg-z-50 gg-order-last gg-mx-auto gg-w-full"
        ></div>
      </main>
    </>
  );
};

export default BusinessConfigurator;
